import { cva, type VariantProps } from "class-variance-authority";

export const statusBadgeVariants = cva(
  "inline-flex items-center gap-1.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default: "text-muted-foreground",
        success: "text-severity-ok",
        warning: "text-severity-warning",
        error: "text-destructive",
        info: "text-severity-info",
        pending: "text-muted-foreground",
      },
      size: {
        default: "text-xs",
        sm: "text-[10px]",
        lg: "text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type StatusBadgeVariantProps = VariantProps<typeof statusBadgeVariants>;
